module.exports = __webpack_public_path__ + "media/images/icons/arrow-right-c6e06d40cddaed11c3728a46f0e9e30a.svg";